import React, { Component, forwardRef, Fragment } from "react";
import LinkCard from "../components/LinkCard";
import { connect } from "react-redux";

//MUI
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { getGroupLink } from "../redux/actions/dataActions";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import axios from "axios";

import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const styles = {
    root: {
        minWidth: "275px",
    },
    center: {
        margin: "auto 1em auto 1em",
        minWidth: "275px",
    },
    containerCentral: {
        justifyContent: "center",
    },
    lightText: {
        fontWeight: "100",
    },
};

class autopilotusers extends Component {
    state = { columns: [], data: [], error: false }

    //TODO: convert to redux paradigm
    componentDidMount() {
        axios
            .get('/api/admin/getUsers') //TODO: parametrize in the future
            .then((res) => {
                function createColumns() {
                    let cols = []
                    cols.push({
                        title: "Email", field: "email", cellStyle: {
                            backgroundColor: '#039be5',
                            color: '#FFF',
                            position: 'sticky',
                            left: 0
                        },
                        headerStyle: {
                            backgroundColor: '#039be5',
                            position: 'sticky',
                            left: 0,
                            zIndex: 11
                        }
                    })
                    cols.push({
                        title: "Creation_time", field: "creation_time", headerStyle: {
                            backgroundColor: '#039be5'
                        }
                    })

                    return cols
                }

                function createData(data) {
                    let ret = []
                    data.forEach(function(item) {
                        let d = {}
                        d["email"] = item[0]
                        d["creation_time"] = item[1]
                        ret.push(d)
                    })
                    return ret
                }
                const { data } = res;
                this.setState({ columns: createColumns(), data: createData(data.users) })
            })
            .catch((err) => {
                console.log(err)
                this.setState({ error: true })
            });
    }

    render() {
        const hasError = this.state.error
        return (
            <Fragment>
                { hasError ?
                    <Typography> Error </Typography> :
                    <div style={{ maxWidth: "100%" }}>
                        <MaterialTable
                            title="Autopilot New User Sign Ups"
                            icons={tableIcons}
                            columns={this.state.columns}
                            data={this.state.data}
                            options={{
                                filtering: true,
                                sorting: true,
                                exportButton: true,
                                pageSize: 10,       // make initial page size
                                emptyRowsWhenPaging: true,   //to make page size fix in case of less data rows
                                pageSizeOptions: [10, 20, 50, 100, 200],
                                headerStyle: {
                                    color: '#FFF',
                                    position: 'sticky',
                                    top: 0
                                }
                            }}
                        />
                    </div>
                }
            </Fragment>
        )

    }
}

export default withStyles(styles)(autopilotusers);
